<template>
  <div v-if="visible" class="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-2xl w-full max-w-md p-8 animate-fade-in relative">
      <button @click="close" class="absolute top-4 right-4 text-gray-medium hover:text-dark transition-custom">
        <i class="fas fa-times text-xl"></i>
      </button>
      <div class="text-center mb-6">
        <h3 class="text-2xl font-bold text-dark">用户登录</h3>
        <p class="mt-2 text-gray-medium">请输入账号信息登录</p>
      </div>
      <form @submit.prevent="handleLogin" class="space-y-5">
        <div>
          <label for="loginPhone" class="block text-sm font-medium text-gray-dark mb-1">手机号码</label>
          <input 
            type="tel" 
            id="loginPhone" 
            v-model="form.phone"
            :disabled="isLoading"
            class="w-full px-4 py-3 border border-gray-light rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition-custom disabled:bg-gray-50 disabled:cursor-not-allowed" 
            placeholder="请输入手机号码"
          >
        </div>
        <div>
          <label for="loginPassword" class="block text-sm font-medium text-gray-dark mb-1">密码</label>
          <input 
            type="password" 
            id="loginPassword" 
            v-model="form.password"
            :disabled="isLoading"
            class="w-full px-4 py-3 border border-gray-light rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none transition-custom disabled:bg-gray-50 disabled:cursor-not-allowed" 
            placeholder="请输入密码"
          >
        </div>
        <div class="flex justify-between items-center">
          <label class="flex items-center">
            <input type="checkbox" v-model="form.remember" :disabled="isLoading" class="w-4 h-4 text-primary focus:ring-primary border-gray-light rounded">
            <span class="ml-2 text-sm text-gray-dark">记住我</span>
          </label>
          <a href="#" class="text-sm text-primary hover:underline">忘记密码？</a>
        </div>
        <button 
          type="submit" 
          :disabled="isLoading"
          class="w-full py-3 bg-primary text-white rounded-lg font-medium hover:bg-primary/90 transition-custom shadow-sm disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center justify-center"
        >
          <span v-if="isLoading" class="inline-flex items-center">
            <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            登录中...
          </span>
          <span v-else>登录</span>
        </button>
      </form>
      <div class="mt-6 text-center">
        <p class="text-sm text-gray-medium">还没有账号？<a href="#" @click="switchToRegister" class="text-primary hover:underline">立即注册</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        phone: '',
        password: '',
        remember: false
      },
      isLoading: false
    }
  },
  methods: {
    close() {
      this.$emit('close')
      document.body.style.overflow = ''
    },
    switchToRegister() {
      this.$emit('switch-to-register')
    },
    async handleLogin() {
      if (this.isLoading) return
      
      this.isLoading = true
      
      try {
        const result = await this.$store.dispatch('login', this.form)
        
        if (result.success) {
          this.$toast.success(result.message)
          this.resetForm()
          this.close()
        } else {
          this.$toast.error(result.message)
          // 登录失败时清空密码
          this.form.password = ''
        }
      } catch (error) {
        console.error('登录处理错误:', error)
        this.$toast.error('登录处理失败，请稍后重试')
        this.form.password = ''
      } finally {
        this.isLoading = false
      }
    },
    resetForm() {
      this.form = {
        phone: '',
        password: '',
        remember: false
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
        // 关闭时重置加载状态
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.transition-custom {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.animate-fade-in {
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
</style> 